export const systembackend_ip = "https://systemend.autorentacar.xyz";
export const websitebackend_ip = "https://websiteend.autorentacar.xyz";
// export const systembackend_ip = "http://localhost:3443";
// export const websitebackend_ip = "http://localhost:3444";